export type CanceledStatus = 'CANCELED';
